;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/:namespace/:slugs*?\",\"regex\":\"^/([^/]+)/([^/]+)(?:/(.*))?$\",\"paramNames\":[\"locale\",\"namespace\",\"slugs\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/internal\",\"regex\":\"^/([^/]+)/internal$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/internal/:namespace/:slugs*?\",\"regex\":\"^/([^/]+)/internal/([^/]+)(?:/(.*))?$\",\"paramNames\":[\"locale\",\"namespace\",\"slugs\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/search\",\"regex\":\"^/([^/]+)/search$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true}],\"staticRoutes\":[{\"path\":\"/oauth\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.1";globalThis["_sentryRewritesTunnelPath"] = "/sentry-monitoring";import * as Sentry from '@sentry/nextjs';
import { getClientEnv } from '@/lib/constants/environment';

const { ENVIRONMENT, SENTRY_DSN, RELEASE } = getClientEnv();

Sentry.init({
  enabled: !!SENTRY_DSN && ENVIRONMENT === 'production',
  dsn: SENTRY_DSN,
  release: RELEASE,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.05,
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 0.05,
  debug: false,

  // Filter out errors from browser extensions and non-app sources
  denyUrls: [
    /extensions\//i,
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
    /^moz-extension:\/\//i,
    /^safari-extension:\/\//i,
    /^edge-extension:\/\//i,
  ],

  // Filter out known third-party and compatibility errors
  ignoreErrors: [
    /Failed to fetch \(api\.vector\.co\)/,
    /Failed to fetch \(px\.ads\.linkedin\.com\)/,
    /Failed to fetch \(ct\.pinterest\.com\)/,
    'Talisman extension has not been configured yet',
    'Invalid call to runtime.sendMessage()',
    /jQuery is not defined/,
  ],
});

// This export will instrument router navigations
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
